import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const Sick: FC = () => {
    return (
        <Box mt={1}>
            <Header>
                <Box display={'flex'}>
                    <Typography mb={1} ml={25}>Строка формы № 16-ВН</Typography>
                    <Typography mb={1} ml={33}>Дата открытия б/л</Typography>
                    <Typography mb={1} ml={9}>Дата закрытия б/л</Typography>
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
            </Header>
            <Body>
                <Box display="flex" alignItems="center">
                    <Typography mr={14.6}>Больничный лист с</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mr: 1 }} 
                    />
                    <Typography mr={1}>по</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mr: 1}} 
                    />
                    <Typography mr={1}>Дата для отчета</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mr: 1}} 
                    />
                    <Typography mr={1}>Кол-во календарных дней</Typography>
                    <TextField
                        label=""
                        variant="outlined"
                        size="small"
                        sx={{ width: "55px", mr: 1}} 
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={1}>№ строки формы 16-ВН</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mb: 1, ml: 8.9, mr: 1}}
                    />
                    <TextField
                        label="Дата приказа"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={1}>Причины нетрудоспособности</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mb: 1, ml: 2.8, mr: 1}}
                    />
                    <TextField
                        label="Дата приказа"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={22.2}>Кем выдан</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={22.4}>№ б/листа</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "300px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={12.9}>Приступить к труду с </Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mb: 1, mr: 1}}
                    />
                </Box>
            </Body>
        </Box>
    );
};

export default Sick;

